
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/diamondhead/change",
      function () {
        return require("private-next-pages/diamondhead/change.js");
      }
    ]);
  